import React from 'react';
import { SnackbarProvider } from 'notistack';
import { Button } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface NotificationProviderProps {
  children: React.ReactNode;
}

const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const notistackRef = React.createRef<any>();

  const onClickDismiss = (key: string | number) => () => {
    notistackRef.current?.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      action={(key) => (
        <Button
          onClick={onClickDismiss(key)}
          color="inherit"
          size="small"
          startIcon={<CloseIcon />}
        >
          Fermer
        </Button>
      )}
      dense
      preventDuplicate
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotificationProvider;
